;; Generated by dev/generate_design.clj — do not edit by hand.
;; Regenerate with: devbox run generate-design
;;
;; A committed mirror of dsl/design/*.edn — the IKC design component
;; library (ADR-graph-ui-v0-019-01). graph-ui.web.widgets reads this to
;; draw a component, so how a row LOOKS lives in the declaration and not
;; in the renderer. Every value here is a token name or a width in ch;
;; validate-dsl fails the source file otherwise.

(ns graph-ui.web.generated-design)

;; QUOTED, so the declaration survives verbatim. Token names are
;; SYMBOLS in the source (`gutter`, `space-1`) — unquoted, ClojureScript
;; would try to resolve each as a var and warn on every one. The themes
;; mirror needs no quote because its keys are keywords.
(def components
  (quote
   {:block-row
 {:component ikc/block-row,
  :facts
  [[block-row is row-of three-tracks]
   [block-row holds number-gutter]
   [block-row holds body]
   [block-row holds right-gutter]
   [block-row can-not set own-width]
   [island can set block-row width]
   [number-gutter can-not move]
   [number-gutter shows position even-for separator]
   [body has indent per-depth]
   [right-gutter sits at-right-edge]
   [right-gutter shows highlights of-this-block]
   [right-gutter is drawn even-when-empty]
   [right-gutter can remove highlight]
   [body has floor measure-floor]
   [body can-not set-fewer-than floor characters]
   [type can shrink below-floor]
   [block-row can-not refuse-to-draw]],
  :variants
  {paragraph
   {:facts [[paragraph shows markdown]], :body {:type type-body}},
   heading
   {:facts [[heading shows markdown] [heading is set-larger]],
    :body {:type type-h2, :tone heading}},
   task
   {:facts [[task holds checkbox] [task can complete]],
    :body {:type type-body, :leading checkbox}},
   separator
   {:facts
    [[separator spans body]
     [separator can-not span past-body]
     [separator shows-not backdrop]],
    :body {:rule {:stroke stroke-hairline, :tone muted}}}},
  :draws
  {:layout :grid,
   :gap space-2,
   :tracks
   [{:cell number-gutter, :width "3.5ch"}
    {:cell body, :width :fill}
    {:cell right-gutter, :width "15ch"}],
   :cells
   {number-gutter
    {:backdrop gutter,
     :stroke stroke-hairline,
     :radius radius-md,
     :type type-micro,
     :tone muted,
     :align :center},
    body
    {:backdrop body,
     :stroke stroke-hairline,
     :radius radius-md,
     :padding {:inline space-3, :block space-2},
     :indent space-5,
     :floor measure-floor},
    right-gutter
    {:backdrop gutter,
     :stroke stroke-hairline,
     :radius radius-md,
     :padding {:inline space-1, :block space-1}}}},
  :gaks-refs
  {:decision
   ["ADR-graph-ui-v0-019-01-design-system-is-the-source"
    "ADR-graph-ui-v0-014-01-ui-building-blocks"
    "ADR-graph-ui-v0-013-01-one-layout-model"],
   :plan ["PLAN-graph-ui-v0-013-01-design-system-as-data"],
   :concept
   ["CONCEPT-graph-ui-v0-006-01-design-token"
    "CONCEPT-graph-ui-v0-009-01-measure-the-reading-column"
    "CONCEPT-graph-ui-v0-011-01-outliner"],
   :spec ["SPEC-graph-ui-v0-003-01-reader-ui-composition"],
   :principle ["PRINCIPLE-ikc-v3-002-01-dsl-first"]}},
 :brand
 {:component ikc/brand,
  :facts
  [[brand holds mark]
   [brand holds wordmark]
   [mark is two-islands]
   [mark shows overlap]
   [mark can-not have-an-edge]
   [mark has clear-space brand-clear-space]
   [mark has minimum-size brand-min-size]
   [mark can theme]
   [wordmark is "ikc3"]
   [wordmark has type type-h1]
   [canvas can-not end]
   [island sits on canvas]
   [island can overlap island]
   [favicon is mark]
   [favicon shows which-is in-front]
   [favicon is built]
   [monochrome-mark is not-built yet]
   [social-card is not-built yet]],
  :variants
  {mark
   {:facts [[mark can stand-alone]],
    :asset "resources/public/brand/ikc-mark.svg"},
   lockup
   {:facts
    [[lockup holds mark]
     [lockup holds wordmark]
     [lockup has gap space-2]]}},
  :draws
  {:layout :grid,
   :gap space-2,
   :tracks [{:cell mark, :width "2ch"} {:cell wordmark, :width :fill}],
   :cells
   {mark {:tone accent}, wordmark {:type type-h1, :tone heading}}},
  :gaks-refs
  {:decision
   ["ADR-graph-ui-v0-019-01-design-system-is-the-source"
    "ADR-graph-ui-v0-009-01-rich-theming-as-data"],
   :plan ["PLAN-graph-ui-v0-013-01-design-system-as-data"],
   :principle ["PRINCIPLE-ikc-v3-011-01-no-crack-between-stages"]}},
 :graph-encoding
 {:component ikc/graph-encoding,
  :facts
  [[graph-encoding is table]
   [graph-encoding shows frame-type as colour]
   [graph-encoding shows frame-type as shape]
   [graph-encoding shows relation as stroke]
   [graph-encoding shows derived as dashed]
   [graph-encoding shows inferred as dotted]
   [graph-encoding can-not set own-width]
   [asserted is drawn-as solid]
   [derived is drawn-as dashed]
   [inferred is drawn-as dotted]
   [inferred is not-built yet]],
  :draws
  {:layout :table,
   :cells
   {node/default {:tone border-2, :shape :circle, :type type-micro},
    edge/derived {:dash :dashed},
    node/tag {:tone hl-2, :shape :pill, :type type-micro},
    edge/depends-on
    {:tone accent, :dash :solid, :rule stroke-hairline},
    edge/tag {:tone hl-2, :dash :dashed, :rule stroke-hairline},
    surface {:tone panel},
    node/outline-node {:tone muted, :shape :square, :type type-micro},
    edge/member-of {:tone good, :dash :solid, :rule stroke-hairline},
    caption {:type type-micro, :tone faint},
    edge/wikilink {:tone accent, :dash :dashed, :rule stroke-emphasis},
    node/block {:tone muted, :shape :square, :type type-micro},
    node/highlight {:tone hl-1, :shape :square, :type type-micro},
    edge/inferred {:dash :dotted},
    edge/default {:tone border-2, :dash :solid, :rule stroke-hairline},
    node/folder {:tone faint, :shape :pill, :type type-micro},
    node/daily {:tone accent-2, :shape :circle, :type type-micro},
    edge/contains
    {:tone accent-soft, :dash :solid, :rule stroke-hairline},
    node/focus {:tone sel, :shape :circle, :type type-small},
    legend {:type type-micro, :tone muted},
    edge/folder {:tone faint, :dash :dashed, :rule stroke-hairline},
    edge/on-page
    {:tone accent-soft, :dash :solid, :rule stroke-hairline},
    edge/child-of
    {:tone accent-soft, :dash :solid, :rule stroke-hairline},
    node/page {:tone accent, :shape :circle, :type type-micro},
    node/project {:tone good, :shape :diamond, :type type-micro},
    node/conversation {:tone hl-3, :shape :circle, :type type-micro}}},
  :gaks-refs
  {:decision
   ["ADR-graph-ui-v0-019-01-design-system-is-the-source"
    "ADR-graph-ui-v0-009-01-rich-theming-as-data"],
   :plan
   ["PLAN-graph-ui-v0-013-01-design-system-as-data"
    "PLAN-ikc-v3-024-01-milestones-rebaselined"],
   :spec ["SPEC-alatus-v0-002-01-ikc1-functional-target"],
   :principle ["PRINCIPLE-ikc-v3-011-01-no-crack-between-stages"]}},
 :icons
 {:component ikc/icons,
  :facts
  [[icons is closed-vocabulary]
   [icon has ikc-name]
   [icon has drawing]
   [drawing is tabler]
   [description can-not name undeclared-icon]
   [icon can-not be undrawn]
   [icon has size one-of [xs sm md lg xl]]
   [icon can take tone]
   [icon-set is not-themed]
   [duotone is not-built yet]],
  :icons
  {:home {:tabler "IconHome", :means "the starting island"},
   :copy {:tabler "IconCopy", :means "copy to the clipboard"},
   :chevron-left {:tabler "IconChevronLeft", :means "go back"},
   :chevron-down
   {:tabler "IconChevronDown", :means "a section that is open"},
   :outline-view {:tabler "IconListTree", :means "the outline view"},
   :chevron-right
   {:tabler "IconChevronRight", :means "a section that is closed"},
   :reveal
   {:tabler "IconFocus2",
    :means
    "show the open page in the tree — added 2026-09-28, bug 7 of IKC3-Bugs-20260928"},
   :folder {:tabler "IconFolder", :means "a vault folder"},
   :check {:tabler "IconCheck", :means "done"},
   :edit {:tabler "IconPencil", :means "edit in place"},
   :file
   {:tabler "IconFileText", :means "a note — NOT a document on disk"},
   :book
   {:tabler "IconBook",
    :means
    "a long read — added 2026-08-15, replaces :book-open which drew nothing"},
   :settings {:tabler "IconSettings", :means "configuration"},
   :theme-config {:tabler "IconPalette", :means "edit the theme"},
   :star {:tabler "IconStar", :means "marked as notable"},
   :chevron-up {:tabler "IconChevronUp", :means "collapse upward"},
   :close {:tabler "IconX", :means "dismiss, never delete"},
   :search {:tabler "IconSearch", :means "search notes and GAKS"},
   :pin {:tabler "IconPin", :means "pinned to the sidebar"},
   :title
   {:tabler "IconHeading",
    :means "a heading block — added 2026-08-15, was silently blank"},
   :theme-selector {:tabler "IconContrast", :means "switch the theme"},
   :calendar {:tabler "IconCalendar", :means "a daily note"},
   :link {:tabler "IconLink", :means "a link between pages"},
   :label
   {:tabler "IconLabel",
    :means "a named label — added 2026-08-15, was silently blank"},
   :plus {:tabler "IconPlus", :means "make a new one"},
   :image
   {:tabler "IconPhoto",
    :means
    "an image in a conversation — added 2026-08-23, PLAN-ikc-v3-017-01 phase 11"},
   :more {:tabler "IconDots", :means "actions that did not fit"},
   :tag {:tabler "IconTag", :means "a tag on a page"},
   :trash
   {:tabler "IconTrash",
    :means "delete — destructive, pair with :danger"},
   :menu {:tabler "IconMenu2", :means "the application menu"}},
  :gaks-refs
  {:decision
   ["ADR-graph-ui-v0-019-01-design-system-is-the-source"
    "ADR-graph-ui-v0-013-01-one-layout-model"],
   :plan ["PLAN-graph-ui-v0-013-01-design-system-as-data"],
   :concept ["CONCEPT-graph-ui-v0-005-01-closed-vocabulary"],
   :principle ["PRINCIPLE-ikc-v3-011-01-no-crack-between-stages"]}},
 :reference-card
 {:component ikc/reference-card,
  :facts
  [[reference-card shows referring-item]
   [reference-card shows what-it-said]
   [reference-card can open referring-item]
   [reference-card can-not set own-width]
   [source sits at-left-edge]
   [quote can wrap]
   [source can wrap]
   [quote shows backlink in-place]
   [sidebar-item shows one-thing]
   [reference-card shows two-things]],
  :variants
  {inline {:facts [[inline is compact]], :quote {:type type-small}}},
  :draws
  {:layout :grid,
   :gap space-3,
   :tracks [{:cell source, :width "50ch"} {:cell quote, :width :fill}],
   :cells
   {source
    {:type type-small,
     :tone accent,
     :backdrop field,
     :radius radius-md,
     :padding {:inline space-2, :block space-1}},
    quote {:type type-small, :tone muted}}},
  :gaks-refs
  {:decision ["ADR-graph-ui-v0-019-01-design-system-is-the-source"],
   :plan ["PLAN-graph-ui-v0-013-01-design-system-as-data"],
   :spec ["SPEC-graph-ui-v0-003-01-reader-ui-composition"],
   :principle ["PRINCIPLE-ikc-v3-011-01-no-crack-between-stages"]}},
 :section-header
 {:component ikc/section-header,
  :facts
  [[section-header shows name]
   [section-header shows count when-known]
   [section-header can fold]
   [section-header holds caret]
   [section-header may-need icon]
   [count sits at-right-edge]
   [section-header can-not set own-width]
   [section-header can-not scroll]
   [section-header sits above collection-list]],
  :variants
  {plain {:facts [[plain shows name]]},
   counted
   {:facts [[counted shows count]],
    :count {:type type-micro, :backdrop accent-soft, :tone accent}}},
  :draws
  {:layout :grid,
   :gap space-2,
   :tracks
   [{:cell caret, :width "2ch"}
    {:cell name, :width :fill}
    {:cell count, :width "6ch"}],
   :cells
   {caret {:type type-micro, :tone faint},
    name {:type type-micro, :tone muted},
    count
    {:type type-micro,
     :tone accent,
     :backdrop accent-soft,
     :radius radius-pill,
     :padding {:inline space-2, :block space-1}}}},
  :gaks-refs
  {:decision ["ADR-graph-ui-v0-019-01-design-system-is-the-source"],
   :plan ["PLAN-graph-ui-v0-013-01-design-system-as-data"],
   :spec ["SPEC-graph-ui-v0-003-01-reader-ui-composition"],
   :principle ["PRINCIPLE-ikc-v3-011-01-no-crack-between-stages"]}},
 :sidebar-item
 {:component ikc/sidebar-item,
  :facts
  [[sidebar-item shows name]
   [sidebar-item may-need icon]
   [sidebar-item may-need accessory]
   [sidebar-item can open page]
   [sidebar-item can-not set own-width]
   [accessory sits at-right-edge]
   [accessory can truncate]
   [open-folder can-not scroll away]
   [open-folder sits below section-header]
   [nested-folder sits below open-folder]
   [sidebar-item has depth]
   [depth has indent per-level]],
  :variants
  {page {:facts [[page can open]], :body {:type type-small}},
   folder
   {:facts [[folder holds many sidebar-item] [folder can fold]],
    :body {:type type-small, :tone text}},
   active
   {:facts [[active is selection]],
    :body {:type type-small, :backdrop hover}},
   dimmed
   {:facts [[dimmed is not-in-scope]],
    :body {:type type-small, :tone faint}}},
  :draws
  {:layout :grid,
   :gap space-1,
   :tracks
   [{:cell caret, :width "1.5ch"}
    {:cell name, :width :fill}
    {:cell accessory, :width "8ch"}],
   :cells
   {caret {:type type-small, :tone faint},
    name {:type type-small, :tone text},
    accessory {:type type-micro, :tone faint}}},
  :gaks-refs
  {:decision ["ADR-graph-ui-v0-019-01-design-system-is-the-source"],
   :plan ["PLAN-graph-ui-v0-013-01-design-system-as-data"],
   :spec ["SPEC-graph-ui-v0-003-01-reader-ui-composition"],
   :principle ["PRINCIPLE-ikc-v3-011-01-no-crack-between-stages"]}},
 :sidebar-section
 {:component ikc/sidebar-section,
  :facts
  [[sidebar-section holds section-header]
   [sidebar-section holds collection-list]
   [sidebar-section can fold]
   [short has height content-up-to-limit]
   [short can scroll past-limit]
   [filling has height all-remaining]
   [filling can scroll]],
  :variants
  {short
   {:facts [[short is recent-or-pinned-or-tags]], :limit {:rows 8}},
   filling {:facts [[filling is all-vaults]]}},
  :draws {:layout :stack, :gap space-1},
  :gaks-refs
  {:decision ["ADR-graph-ui-v0-019-01-design-system-is-the-source"],
   :plan ["PLAN-graph-ui-v0-013-01-design-system-as-data"],
   :spec ["SPEC-alatus-v0-003-02-reader-v3-as-is"],
   :principle ["PRINCIPLE-ikc-v3-011-01-no-crack-between-stages"]}}}
))
